module.exports = __webpack_public_path__ + "static/img/shop_area_1.eef97fa8.jpg";